import { Tabs } from "@shared/ui/tabs";
import { Edit3, FileText } from "lucide-react";
import { BulkBillDraft } from "./bulkBillDraft";
import { BulkBillTable } from "./bulkBillTable";

export const BulkBillTab = () => {
  // Define subtab components
  const bulkBillSubTabs = {
    "all-bills": {
      label: "All Bills",
      icon: <FileText className="h-4 w-4" />,
      component: <BulkBillTable />,
    },
    "draft-bills": {
      label: "Draft Bills",
      icon: <Edit3 className="h-4 w-4" />,
      component: <BulkBillDraft />,
    },
  };

  return (
    <div className="space-y-4">
      <Tabs
        tabComponents={bulkBillSubTabs}
        defaultValue="all-bills"
        urlMapping={{
          "all-bills": "all",
          "draft-bills": "draft",
        }}
        tabsListClassName="w-fit grid grid-cols-2 bg-muted/30 p-1"
        idPrefix="bulk-bill-subtab"
        level={1}
      />
    </div>
  );
};
